<template>
  <div class="social-links__container">
    <social-link-item
      v-for="socialLink in socialLinks"
      :key="socialLink.url"
      v-bind="socialLink"
    />
  </div>
</template>

<script>
import {
  faInstagram,
  faTelegramPlane,
  faLinkedinIn,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import SocialLinkItem from './SocialLinkItem';

export default {
  name: 'SocialLinks',
  components: {
    SocialLinkItem,
  },
  data() {
    return {
      socialLinks: [
        {
          url: 'https://www.instagram.com/ddc.by',
          fortAwesomeIcon: faInstagram,
        },
        {
          url: 'https://t.me/ddc202',
          fortAwesomeIcon: faTelegramPlane,
        },
        {
          url: 'https://www.linkedin.com/company/digital_development_center/?viewAsMember=true',
          fortAwesomeIcon: faLinkedinIn,
        },
        {
          url: 'https://www.youtube.com/channel/UCvJ2djjv-vd-m44XAXDDxXA',
          fortAwesomeIcon: faYoutube,
        },
      ],
    };
  },
};
</script>

<style lang="stylus" scoped>
.social-links__container {
  display: flex;
}
</style>
